import React, { FC } from 'react'
import { createStyles, makeStyles, Typography } from '@material-ui/core';

// eslint-disable-next-line
interface Page404Props { }

const Page404: FC<Page404Props> = () => {

    // eslint-disable-next-line
    const classes = useStyles();
    return (
        <div>
            <Typography variant="h2">404: Page Not Found</Typography>
        </div>
    )
}

const useStyles = makeStyles((theme) => createStyles({

}));

export default Page404;